app.service('announcementModal', function (modal, loading, html, localStorage, logData) {
	let $self, $modal;

	function openAnnouncementModal(){
		if(!$modal){
			$modal = modal.open('announcement', {
				modifier:'remodal-bottom',
				closeOnEscape: false,
				closeOnOutsideClick: false,
			});
		} else {
			$modal.open();
		}
		html.remove('remodal-is-locked');
	}
	function closeAnnouncementModal(){
		$modal.close();
	}
	function minimalize() {
		closeAnnouncementModal();
		UA.interaction('Konto Klienta','Warstwa Nowości i zmiany','Minimalizowanie');
	}
	function maximalize() {
		openAnnouncementModal();
		UA.interaction('Konto Klienta','Warstwa Nowości i zmiany','Maksymalizowanie');
	}

	function hideAnnouncement(dataId) {
		let $announcementBlock = $('[data-announcement-id="'+dataId+'"]', $self);
		let $totalAnnouncements = $('.js-total-announcement-count');
		let totalAnnouncementsCount = $totalAnnouncements.first().text()/1;
		if (totalAnnouncementsCount == 1) {
			html.remove('announcement-active');
			closeAnnouncementModal();
			return;
		}
		if ($announcementBlock.length > 0) {
			$announcementBlock.hide();
			$totalAnnouncements.text(totalAnnouncementsCount - 1);
		}
	}

	function sendVoucher(voucherId, voucherHref){
		hideAnnouncement(voucherId);
		$.ajax({
			type: 'POST',
			url:'/customer-to-voucher-announcement-update.ltr',
			data:{
				voucherId:voucherId
			},
			success:function(json){
				if(voucherHref) {
					minimalize();
					loading.redirect(voucherHref);
				}
			},
			error:function(){
				modal.alert('Wystąpił błąd podczas wysyłania danych o dostępnym kodzie rabatowym.');
			}
		});
	}

	function send(announcementId, announcementHref){
		$.ajax({
			type: 'POST',
			url:'/customer-to-announcement-update.ltr',
			data:{
				announcementId:announcementId
			},
			success:function(json){
				if(announcementHref && announcementHref !== '#'){
					minimalize();
					loading.redirect(announcementHref);
				}
			},
			error:function(){
				modal.alert('Wystąpił błąd podczas wysyłania danych dla powiadomienia.');
			}
		});
		hideAnnouncement(announcementId);
	}

	function setEvents() {
		$self.on('click', '.js-announcement-next', function(e){
			e.preventDefault();
			UA.interaction('Konto Klienta','Warstwa Nowości i zmiany','Nowość','Kliknięcie CTA');
			const $announcementBlock = $(this).closest('.announcement-block');
			send($announcementBlock.data('announcement-id'), $(this).attr('href'));
		});
		$self.on('click', '.js-announcement-dismiss', function(){
			UA.interaction('Konto Klienta','Warstwa Nowości i zmiany','Nowość','Pomiń');
			const $announcementBlock = $(this).closest('.announcement-block');
			send($announcementBlock.data('announcement-id'));
			$announcementBlock.hide();
		});

		$self.on('click', '.js-voucher-next', function(e){
			e.preventDefault();
			UA.interaction('Konto Klienta','Warstwa Nowości i zmiany','Voucher','Kliknięcie CTA');
			const $voucherBlock = $(this).closest('.announcement-block');
			sendVoucher($voucherBlock.data('announcement-id'), $(this).attr('href'));
		});
		$self.on('click', '.js-voucher-dismiss', function(){
			UA.interaction('Konto Klienta','Warstwa Nowości i zmiany','Voucher','Pomiń');
			const $voucherBlock = $(this).closest('.announcement-block');
			sendVoucher($voucherBlock.data('announcement-id'));
		});

		$('body').on('click', '.js-close-announcements', function(e){
			minimalize();
		});
		$('body').on('click', '.js-open-announcements', function(e){
			maximalize();
		});
	}

	function init() {
		$self = $('#modal-announcement');
		if ($self.length && !$('.remodal-is-opening, .remodal-is-opened').length){
			// domyślnie zminimalizowane, użytkownik może rozwinąć modal klikając w element
			html.add('announcement-active');
			UA.interaction('Konto Klienta','Warstwa Nowości i zmiany', 'Wyświetlenie');
			setEvents();
		}
	}

	return {
		init
	};
});
